<template>
  <div class="allorders">
    <edit-order :show='edit_show'
                :orderId='orderData'
                @change='onChange'>
    </edit-order>
    <!-- 查询订单 -->
    <div class="allorders_search"
         :style="'height:'+(search+100)+'px'">
      <el-form class="allorders_search_form"
               :style="'height:'+search+'px'">

        <!-- 物流单号 -->
        <el-form-item class="allorders_search_item"
                      label='物流单号'>
          <el-input placeholder="根据物流单号查询"
                    v-model="queryCondition.wlnum"
                    id="wlnum"></el-input>
        </el-form-item>

        <!-- 订单状态 -->
        <el-form-item class="allorders_search_item"
                      label='订单状态'>
          <el-select v-model="queryCondition.status"
                     placeholder="根据订单状态查询">
            <el-option v-for="item in orderStatus"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <!-- 订单状态 -->
        <el-form-item class="allorders_search_item"
                      label='订单类型'>
          <el-select v-model="queryCondition.selectType"
                     placeholder="查询集运/商业件">
            <el-option v-for="item in selectTypeOption"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <!-- 收件国家 -->
        <el-form-item class="allorders_search_item"
                      label='国家查询'>
          <div class="shipping_address">
            <el-cascader :props="props"
                         v-model="queryCondition.addrid">
            </el-cascader>
          </div>
        </el-form-item>

        <!-- 收件姓名 -->
        <el-form-item class="allorders_search_item"
                      label='收件姓名'>
          <el-input placeholder="根据收件人姓名查询"
                    v-model="queryCondition.keyword"> </el-input>
        </el-form-item>

        <!-- 报价方案 -->
        <el-form-item class="allorders_search_item"
                      label='报价方案'>
          <el-select v-model="queryCondition.bjID"
                     placeholder="根据报价方案id查询">
            <el-option v-for="item in bjlist"
                       :key="item.value"
                       :label="item.label.bjname"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <!-- 渠道查询 -->
        <el-form-item class="allorders_search_item"
                      label='渠道查询'>
          <el-select v-model="queryCondition.qdID"
                     placeholder="根据渠道id进行查询">
            <el-option v-for="item in qdlist"
                       :key="item.value"
                       :label="item.label.channelname"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <!-- 送件方式 -->
        <el-form-item class="allorders_search_item"
                      label='送件方式'>
          <el-select v-model="queryCondition.fromtype"
                     placeholder="根据送货方式进行查询">
            <el-option v-for="item in fromtype"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <!-- 用户查询 -->
        <el-form-item class="allorders_search_item"
                      label='ID查询'>
          <el-input placeholder="根据用户id进行查询"
                    v-model="queryCondition.uid"> </el-input>
        </el-form-item>

        <!-- 时间查询 -->
        <el-form-item class="allorders_search_item allorders_search_time"
                      label='下单时间'>
          <el-date-picker v-model="queryCondition.ordertime.start"
                          type="datetime"
                          placeholder="开始时间"
                          align="right"
                          default-time="12:00:00"
                          value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
          <el-date-picker v-model="queryCondition.ordertime.end"
                          type="datetime"
                          placeholder="截止时间"
                          align="right"
                          default-time="12:00:00"
                          value-format="yyyy-MM-dd HH:mm:ss"
                          :picker-options="pickerOptions">
          </el-date-picker>
        </el-form-item>

        <!-- 快递单号 -->
        <el-form-item class="allorders_search_item"
                      label='快递单号'>
          <el-input placeholder='根据快递单号查询'
                    v-model="queryCondition.kdnum"
                    id="kdnum"> </el-input>
        </el-form-item>

        <!-- 仓库id -->
        <el-form-item class="allorders_search_item"
                      label='仓库查询'>
          <el-select v-model="queryCondition.ckid"
                     placeholder="根据订单状态查询">
            <el-option v-for="item in warehouseChoose"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>

      </el-form>
      <div class="viewMore">
        <span @click="moreClick"
              :class='search_flag?"el-icon-arrow-down":"el-icon-arrow-up"'
              class=" animate__animated animate__fadeInDown "></span>
      </div>
      <div class="operation_button">
        <!-- 控制按钮 -->
        <div class="operation_button_main">
          <el-dropdown :hide-on-click="false"
                       size="medium"
                       split-button
                       @click='exhibitionData=true'>
            <span class="el-dropdown-link">
              展示内容
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <el-checkbox v-model="tableShowData.wlnum">物流单号</el-checkbox>
              </el-dropdown-item>
              <el-dropdown-item>
                <el-checkbox v-model="tableShowData.zt">订单状态</el-checkbox>
              </el-dropdown-item>
              <el-dropdown-item>
                <el-checkbox v-model="tableShowData.addrid">收件国家</el-checkbox>
              </el-dropdown-item>
              <el-dropdown-item>
                <el-checkbox v-model="tableShowData.sjname">收件姓名</el-checkbox>
              </el-dropdown-item>
              <el-dropdown-item>
                <el-checkbox v-model="tableShowData.kdnum">快递单号</el-checkbox>
              </el-dropdown-item>
              <el-dropdown-item>
                <el-checkbox v-model="tableShowData.ckid">仓库名称</el-checkbox>
              </el-dropdown-item>
              <el-dropdown-item>
                <el-checkbox v-model="tableShowData.operation">操作</el-checkbox>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-dialog title="展示内容"
                     :visible.sync="exhibitionData"
                     class="exhibitionData">
            <span class="exhibitionData_span">
              <el-checkbox v-model="tableShowData.wlnum">物流单号</el-checkbox>
              <el-checkbox v-model="tableShowData.zt">订单状态</el-checkbox>
              <el-checkbox v-model="tableShowData.addrid">收件国家</el-checkbox>
              <el-checkbox v-model="tableShowData.sjname">收件姓名</el-checkbox>
              <el-checkbox v-model="tableShowData.kdnum">快递单号</el-checkbox>
              <el-checkbox v-model="tableShowData.ckid">仓库名称</el-checkbox>
              <el-checkbox v-model="tableShowData.operation">操作</el-checkbox>
            </span>
            <hr>
            <span class="exhibitionData_span">
              <el-checkbox v-model="tableShowData.id">订单id</el-checkbox>
              <el-checkbox v-model="tableShowData.cid">渠道</el-checkbox>
              <el-checkbox v-model="tableShowData.bjinfo">报价</el-checkbox>
              <el-checkbox v-model="tableShowData.weight">总重量</el-checkbox>
              <el-checkbox v-model="tableShowData.tj">总体积</el-checkbox>
              <el-checkbox v-model="tableShowData.ofromtype">送件类型</el-checkbox>
              <el-checkbox v-model="tableShowData.uniacid"
                           disabled>订单公众号id</el-checkbox>
            </span>
            <hr>
            <span class="exhibitionData_span">
              <el-checkbox v-model="tableShowData.paytype">付款类型</el-checkbox>
              <el-checkbox v-model="tableShowData.feeprice">手续费</el-checkbox>
              <el-checkbox v-model="tableShowData.dsprice">代收款金额</el-checkbox>
              <el-checkbox v-model="tableShowData.gqprice">改签地址费用</el-checkbox>
              <el-checkbox v-model="tableShowData.allprice">订单总价</el-checkbox>
            </span>
            <hr>
            <span class="exhibitionData_span">
              <el-checkbox v-model="tableShowData.jjmobile">寄件人电话</el-checkbox>
              <el-checkbox v-model="tableShowData.jjname">寄件人姓名</el-checkbox>
              <el-checkbox v-model="tableShowData.jjprovince">寄件人省份</el-checkbox>
              <el-checkbox v-model="tableShowData.jjcity">寄件人城市</el-checkbox>
              <el-checkbox v-model="tableShowData.jjdistrict">寄件人街道</el-checkbox>
              <el-checkbox v-model="tableShowData.jjzipcode">寄件人邮编</el-checkbox>
              <el-checkbox v-model="tableShowData.jjaddress">寄件人详细地址</el-checkbox>
            </span>
            <hr>
            <span class="exhibitionData_span">
              <el-checkbox v-model="tableShowData.sjmobile">收件人电话</el-checkbox>
              <el-checkbox v-model="tableShowData.sjprovince">收件人省份</el-checkbox>
              <el-checkbox v-model="tableShowData.sjcity">收件人城市</el-checkbox>
              <el-checkbox v-model="tableShowData.sjdistrict">收件人区域</el-checkbox>
              <el-checkbox v-model="tableShowData.sjzipcode">收件人邮编</el-checkbox>
              <el-checkbox v-model="tableShowData.sjaddress">收件人详细地址</el-checkbox>
            </span>
            <hr>
            <span class="exhibitionData_span">
              <el-checkbox v-model="tableShowData.bgnum">包裹数量（箱数）</el-checkbox>
              <el-checkbox v-model="tableShowData.zynum">转运单号</el-checkbox>
              <el-checkbox v-model="tableShowData.zyckid">转运仓库ID</el-checkbox>
              <el-checkbox v-model="tableShowData.qjstartime">取件开始时间</el-checkbox>
              <el-checkbox v-model="tableShowData.qjendtime">取件结束时间</el-checkbox>
              <el-checkbox v-model="tableShowData.qjuid">取件司机用户ID</el-checkbox>
              <el-checkbox v-model="tableShowData.qjbzinfo">取件备注信息</el-checkbox>
              <el-checkbox v-model="tableShowData.tjuid">推介人ID</el-checkbox>
              <el-checkbox v-model="tableShowData.createtime">订单创建时间</el-checkbox>
              <el-checkbox v-model="tableShowData.edittime">更新时间</el-checkbox>
              <el-checkbox v-model="tableShowData.info">订单备注</el-checkbox>
            </span>
          </el-dialog>

          <span class="tabelBorder">
            边框:
            <el-switch v-model="isTabelBorder"
                       active-color="#13ce66"
                       inactive-color="#ccc">
            </el-switch>
          </span>

          <span class="tabelBorder">
            多选:
            <el-switch v-model="isCheckbox"
                       active-color="#13ce66"
                       inactive-color="#ccc">
            </el-switch>
          </span>

          <span class="tabelBorder">
            隐藏取消单:
            <el-switch v-model="isShowCancel"
                       @change='concealOrder'
                       label='tabelBorder'
                       active-color="#13ce66"
                       inactive-color="#ccc">
            </el-switch>
          </span>

        </div>
        <!-- 查询按钮 -->
        <div class="allorders_search_but">

          <el-button type='primary'
                     @click="trackOrder()">查询
          </el-button>
          <el-button type='info'
                     @click='resetData()'>重置
          </el-button>
          <el-button @click="isExportExcel = true,tableShowData.operation = false"
                     type='primary'>导出</el-button>
        </div>
      </div>
    </div>

    <!-- 订单展示 -->
    <div class="orderShow">
      <el-table :data="tableData"
                style="width: 100%"
                height="80%"
                v-loading="loading"
                :border='isTabelBorder'
                id="main_table"
                @select='storeData'>

        <el-table-column type="selection"
                         v-if="isCheckbox"
                         width=50>
        </el-table-column>

        <el-table-column label="订单ID"
                         v-if="tableShowData.id">
          <template slot-scope="scope">
            <span>{{scope.row.id}}</span>
          </template>
        </el-table-column>

        <el-table-column label="报价"
                         v-if="tableShowData.bjinfo">
          <template slot-scope="scope">
            <span>{{scope.row.bjinfo}}</span>
          </template>
        </el-table-column>

        <el-table-column label="渠道"
                         v-if="tableShowData.cid">
          <template slot-scope="scope">
            <span>{{scope.row.qdname}}</span>
          </template>
        </el-table-column>

        <el-table-column label="转运单号"
                         v-if="tableShowData.zynum">
          <template slot-scope="scope">
            <span>{{scope.row.zynum}}</span>
          </template>
        </el-table-column>

        <el-table-column label="转运仓库ID"
                         v-if="tableShowData.zyckid">
          <template slot-scope="scope">
            <span>{{scope.row.zyckid}}</span>
          </template>
        </el-table-column>

        <el-table-column label="取件开始时间"
                         v-if="tableShowData.qjstartime">
          <template slot-scope="scope">
            <span>{{scope.row.qjstartime}}</span>
          </template>
        </el-table-column>

        <el-table-column label="取件结束时间"
                         v-if="tableShowData.qjendtime">
          <template slot-scope="scope">
            <span>{{scope.row.qjendtime}}</span>
          </template>
        </el-table-column>

        <el-table-column label="取件司机用户ID"
                         v-if="tableShowData.qjuid">
          <template slot-scope="scope">
            <span>{{scope.row.qjuid}}</span>
          </template>
        </el-table-column>

        <el-table-column label="取件备注信息"
                         v-if="tableShowData.qjbzinfo">
          <template slot-scope="scope">
            <span>{{scope.row.qjbzinfo}}</span>
          </template>
        </el-table-column>

        <el-table-column label="推介人ID"
                         v-if="tableShowData.tjuid">
          <template slot-scope="scope">
            <span>{{scope.row.tjuid}}</span>
          </template>
        </el-table-column>

        <el-table-column label="订单创建时间"
                         v-if="tableShowData.createtime">
          <template slot-scope="scope">
            <span>{{scope.row.createtime}}</span>
          </template>
        </el-table-column>

        <el-table-column label="更新时间"
                         v-if="tableShowData.edittime">
          <template slot-scope="scope">
            <span>{{scope.row.edittime}}</span>
          </template>
        </el-table-column>

        <el-table-column prop="wlnum"
                         label="物流单号"
                         v-if="tableShowData.wlnum">
        </el-table-column>

        <el-table-column label="订单状态"
                         v-if="tableShowData.zt">
          <template slot-scope="scope">
            <span>{{scope.row.ozt}}</span>
            <!-- <span>{{tableShowData.zt[scope.row.type][scope.row.fromtype][scope.row.status]}}</span> -->
          </template>
        </el-table-column>

        <el-table-column label="送件类型"
                         v-if="tableShowData.ofromtype">
          <template slot-scope="scope">
            <span>{{scope.row.ofromtype}}</span>
          </template>
        </el-table-column>

        <el-table-column label="付款类型"
                         v-if="tableShowData.paytype">
          <template slot-scope="scope">
            <span>{{scope.row.paytype==1?'自付':'到付'}}</span>
          </template>
        </el-table-column>

        <el-table-column label="包裹数量（箱数）"
                         v-if="tableShowData.bgnum">
          <template slot-scope="scope">
            <span>{{scope.row.bgnum}}</span>
          </template>
        </el-table-column>

        <el-table-column label="手续费"
                         v-if="tableShowData.feeprice">
          <template slot-scope="scope">
            <span>{{scope.row.feeprice}}RMB</span>
          </template>
        </el-table-column>

        <el-table-column label="代收款"
                         v-if="tableShowData.dsprice">
          <template slot-scope="scope">
            <span>{{scope.row.dsprice}}</span>
          </template>
        </el-table-column>

        <el-table-column label="改签费用"
                         v-if="tableShowData.gqprice">
          <template slot-scope="scope">
            <span>{{scope.row.gqprice}}</span>
          </template>
        </el-table-column>

        <el-table-column label="订单总价"
                         v-if="tableShowData.allprice">
          <template slot-scope="scope">
            <span>{{scope.row.allprice}}</span>
          </template>
        </el-table-column>

        <el-table-column label="总重量"
                         v-if="tableShowData.weight">
          <template slot-scope="scope">
            <span>{{scope.row.weight}} KG</span>
          </template>
        </el-table-column>

        <el-table-column label="总体积"
                         v-if="tableShowData.tj">
          <template slot-scope="scope">
            <span>{{scope.row.tj / 1000000}} 立方米</span>
          </template>
        </el-table-column>

        <el-table-column label="寄件人电话"
                         v-if="tableShowData.jjmobile">
          <template slot-scope="scope">
            <span>{{scope.row.jjmobile}}</span>
          </template>
        </el-table-column>

        <el-table-column label="寄件人姓名"
                         v-if="tableShowData.jjname">
          <template slot-scope="scope">
            <span>{{scope.row.jjname}}</span>
          </template>
        </el-table-column>

        <el-table-column label="寄件人省份"
                         v-if="tableShowData.jjprovince">
          <template slot-scope="scope">
            <span>{{scope.row.jjprovince}}</span>
          </template>
        </el-table-column>

        <el-table-column label="寄件人城市"
                         v-if="tableShowData.jjcity">
          <template slot-scope="scope">
            <span>{{scope.row.jjcity}}</span>
          </template>
        </el-table-column>

        <el-table-column label="寄件人街道"
                         v-if="tableShowData.jjdistrict">
          <template slot-scope="scope">
            <span>{{scope.row.jjdistrict}}</span>
          </template>
        </el-table-column>

        <el-table-column label="寄件人详细地址"
                         v-if="tableShowData.jjaddress">
          <template slot-scope="scope">
            <span>{{scope.row.jjaddress.jjaddress}}</span>
          </template>
        </el-table-column>

        <el-table-column label="寄件人邮编"
                         v-if="tableShowData.jjzipcode">
          <template slot-scope="scope">
            <span>{{scope.row.jjzipcode}}</span>
          </template>
        </el-table-column>

        <el-table-column label="收件国家"
                         v-if="tableShowData.addrid">
          <template slot-scope="scope">
            <span>{{ scope.row.gj?scope.row.gj:'未生成' }}</span>
          </template>
        </el-table-column>

        <el-table-column label="收件人电话"
                         v-if="tableShowData.sjmobile">
          <template slot-scope="scope">
            <span>{{scope.row.sjmobile}}</span>
          </template>
        </el-table-column>

        <el-table-column label="收件人省份"
                         v-if="tableShowData.sjprovince">
          <template slot-scope="scope">
            <span>{{scope.row.sjprovince}}</span>
          </template>
        </el-table-column>

        <el-table-column label="收件人城市"
                         v-if="tableShowData.sjcity">
          <template slot-scope="scope">
            <span>{{scope.row.sjcity}}</span>
          </template>
        </el-table-column>

        <el-table-column label="收件人区域"
                         v-if="tableShowData.sjdistrict">
          <template slot-scope="scope">
            <span>{{scope.row.sjdistrict}}</span>
          </template>
        </el-table-column>

        <el-table-column label="收件人邮编"
                         v-if="tableShowData.sjzipcode">
          <template slot-scope="scope">
            <span>{{scope.row.sjzipcode}}</span>
          </template>
        </el-table-column>

        <el-table-column label="收件人详细地址"
                         v-if="tableShowData.sjaddress">
          <template slot-scope="scope">
            <span>{{scope.row.sjaddress.sjaddress}}</span>
          </template>
        </el-table-column>

        <el-table-column label="收件姓名"
                         v-if="tableShowData.sjname">
          <template slot-scope="scope">
            <span>{{scope.row.sjname?scope.row.sjname:'未生成'}}</span>
          </template>
        </el-table-column>

        <el-table-column prop="kdnum"
                         label="快递单号"
                         v-if="tableShowData.kdnum">
          <template slot-scope="scope">
            <span v-if="scope.row.kdnum">{{scope.row.kdnum}}</span>
            <span v-else
                  style="color:#999">未生成</span>
          </template>
        </el-table-column>

        <el-table-column label="仓库名称"
                         v-if="tableShowData.ckid">
          <template slot-scope="scope">
            <el-tooltip class="item"
                        effect="dark"
                        :content="scope.row.ckname"
                        transition='el-zoom-in-bottom'
                        placement="top-start">
              <span class="warehouseName">{{ scope.row.ckname}}</span>

            </el-tooltip>
          </template>

        </el-table-column>

        <el-table-column label="订单备注"
                         v-if="tableShowData.info">
          <template slot-scope="scope">
            <span>{{scope.row.info}}</span>
          </template>
        </el-table-column>

        <el-table-column label="操作"
                         width="350"
                         align="right"
                         v-if="tableShowData.operation">
          <template slot-scope="scope">

            <div>
              <el-tooltip class="item"
                          effect="dark"
                          content="详情"
                          transition='el-zoom-in-bottom'
                          placement="top-start">
                <el-button type='primary'
                           size="mini"
                           icon='el-icon-view'
                           @click='orderIDdetails(scope.row)'>

                </el-button>
              </el-tooltip>

              <el-tooltip class="item"
                          effect="dark"
                          content="编辑订单"
                          transition='el-zoom-in-bottom'
                          placement="top-start">
                <el-button type='primary'
                           v-if="scope.row.status>=0&&scope.row.status<=2"
                           size="mini"
                           icon="el-icon-edit"
                           @click='modifyOrder(scope.row)'>

                </el-button>
              </el-tooltip>

              <el-tooltip class="item"
                          effect="dark"
                          content="取消"
                          transition='el-zoom-in-bottom'
                          placement="top-start">
                <el-button type='danger'
                           v-if="scope.row.status==0||scope.row.status==1||scope.row.status==2"
                           size="mini"
                           @click='removeOrder(scope.row.id)'
                           icon="el-icon-delete">
                </el-button>
              </el-tooltip>
            </div>

          </template>
        </el-table-column>

        <div slot="empty">
          <span>没有找到订单哦，请重置。</span>

        </div>
      </el-table>
      <div class="paging">
        <div class="block">
          <el-pagination @size-change="handleChange"
                         @current-change="pageData"
                         :current-page="currentPage"
                         :page-sizes='pageSizeArr'
                         :page-size="pageSize"
                         layout="total, sizes, prev, pager, next, jumper"
                         :total="ordernum">
          </el-pagination>
        </div>
      </div>
    </div>

    <div class="pop">
      <!-- 控制页面 -->
      <el-dialog title="订单详情"
                 :visible.sync="dialogTableVisible"
                 width="1100px"
                 class="dialogTableVisible_1">
        <div class="order_details">
          <h4 class="order_details_title">地址信息</h4>
          <el-row :gutter="5">
            <el-col :span="3">
              <div class="grid-content ">
                <div class="details_title">
                  寄件人姓名
                </div>
                <div class="details_content">
                  {{orderID.jjname||'未选择报价'}}
                </div>
              </div>
            </el-col>
            <el-col :span="4">
              <div class="grid-content ">
                <div class="details_title">
                  寄件人电话
                </div>
                <div class="details_content">
                  <span v-if="orderID.jjmobile">{{orderID.jjmobile}}</span>
                  <span v-else
                        style="color:#999">选择报价后生成</span>
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content ">
                <div class="details_title">
                  寄件详细地址
                </div>
                <div class="details_content">
                  {{orderID.jjprovince+' '+orderID.jjcity+' '+orderID.jjdistrict+' '+orderID.jjaddress}}
                </div>
              </div>
            </el-col>
            <el-col :span="3">
              <div class="grid-content ">
                <div class="details_title">
                  邮政编码
                </div>
                <div class="details_content">
                  <span v-if="orderID.jjzipcode">{{orderID.jjzipcode}}</span>
                  <span v-else
                        style="color:#999">未填写</span>
                </div>
              </div>
            </el-col>
            <el-col :span="4">
              <div class="grid-content ">
                <div class="details_title">
                  寄件公司名
                </div>
                <div class="details_content">
                  <span v-if="orderID.jjcompanyname">{{orderID.jjcompanyname}}</span>
                  <span v-else
                        style="color:#999">未填写</span>
                </div>
              </div>
            </el-col>
            <el-col :span="4">
              <div class="grid-content ">
                <div class="details_title">
                  寄件公司税号（ EORI ）
                </div>
                <div class="details_content">
                  <span v-if="orderID.jjcompanytaxid">{{orderID.jjcompanytaxid}}</span>
                  <span v-else
                        style="color:#999">未填写</span>
                </div>
              </div>
            </el-col>

            <el-col :span="3">
              <div class="grid-content ">
                <div class="details_title">
                  收件人姓名 | 代码
                </div>
                <div class="details_content">
                  {{orderID.sjname||'未选择报价'}}
                </div>
              </div>
            </el-col>

            <el-col :span="4">
              <div class="grid-content ">
                <div class="details_title">
                  收件人电话
                </div>
                <div class="details_content">
                  <span v-if="orderID.sjmobile">{{orderID.sjmobile}}</span>
                  <span v-else
                        style="color:#999">用户未选择 | FBA无需电话</span>
                </div>
              </div>
            </el-col>

            <el-col :span="6">
              <div class="grid-content ">
                <div class="details_title">
                  收件人详细地址
                </div>
                <div class="details_content">
                  {{`${orderID.gjname||''} ${orderID.sjprovince||''} ${orderID.sjcity||''} ${orderID.sjdistrict||''} ${orderID.sjaddress||''}`}}
                </div>
              </div>
            </el-col>

            <el-col :span="3">
              <div class="grid-content ">
                <div class="details_title">
                  邮政编码
                </div>
                <div class="details_content">
                  <span v-if="orderID.sjzipcode">{{orderID.sjzipcode}}</span>
                  <span v-else
                        style="color:#999">未填写</span>
                </div>
              </div>
            </el-col>

            <el-col :span="4">
              <div class="grid-content ">
                <div class="details_title">
                  收件公司名
                </div>
                <div class="details_content">
                  <span v-if="orderID.sjcompanyname">{{orderID.sjcompanyname}}</span>
                  <span v-else
                        style="color:#999">未填写</span>
                </div>
              </div>
            </el-col>

            <el-col :span="4">
              <div class="grid-content ">
                <div class="details_title">
                  收件公司税号（ EORI ）
                </div>
                <div class="details_content">
                  <span v-if="orderID.sjcompanytaxid">{{orderID.sjcompanytaxid}}</span>
                  <span v-else
                        style="color:#999">未填写</span>
                </div>
              </div>
            </el-col>

          </el-row>
          <h4 class="order_details_title">订单信息</h4>
          <el-row :gutter="5">

            <el-col :span="3">
              <div class="grid-content ">
                <div class="details_title">
                  订单ID
                </div>
                <div class="details_content">
                  <span>{{orderID.id}}</span>
                </div>
              </div>
            </el-col>

            <el-col :span="3">
              <div class="grid-content ">
                <div class="details_title">
                  订单类型
                </div>
                <div class="details_content">
                  <span>{{orderID.fromtype==1?'自寄':orderID.fromtype==2?'上门取件':'自送仓库'}}</span>
                </div>
              </div>
            </el-col>

            <el-col :span="3">
              <div class="grid-content ">
                <div class="details_title">
                  送件类型
                </div>
                <div class="details_content">
                  <span>{{orderID.fromtype==1?'自寄':orderID.fromtype==2?'上门取件':'自送仓库'}}</span>
                </div>
              </div>
            </el-col>

            <el-col :span="5">
              <div class="grid-content ">
                <div class="details_title">
                  物流单号
                </div>
                <div class="details_content">
                  <span v-if="orderID.wlnum">{{orderID.wlnum}}</span>
                  <span v-else
                        style="color:#999">集运订单选择报价后生成</span>
                </div>
              </div>
            </el-col>

            <el-col :span="5">
              <div class="grid-content ">
                <div class="details_title">
                  快递单号
                </div>
                <div class="details_content">
                  <span v-if="orderID.wlnum">{{orderID.wlnum}}</span>
                  <span v-else
                        style="color:#999">集运订单选择报价后生成</span>
                </div>
              </div>
            </el-col>

            <el-col :span="5">
              <div class="grid-content ">
                <div class="details_title">
                  转运单号
                </div>
                <div class="details_content">
                  <span v-if="orderID.zynum!=0">{{orderID.zynum}}</span>
                  <span v-else
                        style="color:#999">后台添加后显示</span>
                </div>
              </div>
            </el-col>

            <el-col :span="3">
              <div class="grid-content ">
                <div class="details_title">
                  包裹总体积
                </div>
                <div class="details_content">
                  <span v-if="orderID.tj">{{orderID.tj/1000000}} CBM</span>
                  <span v-else
                        style="color:#999">待测量</span>
                </div>
              </div>
            </el-col>

            <el-col :span="3">
              <div class="grid-content ">
                <div class="details_title">
                  包裹总重量
                </div>
                <div class="details_content">
                  <span v-if="orderID.weight">{{orderID.weight}}</span>
                  <span v-else
                        style="color:#999">待测量</span>
                </div>
              </div>
            </el-col>
            <el-col :span="3">
              <div class="grid-content ">
                <div class="details_title">
                  计费重
                </div>
                <div class="details_content">
                  {{priceWeight+'KG'||'未生成'}}
                </div>
              </div>
            </el-col>
            <el-col :span="3">
              <div class="grid-content ">
                <div class="details_title">
                  包裹数量
                </div>
                <div class="details_content">
                  <span v-if="orderID.bgnum">{{orderID.bgnum}}</span>
                  <span v-else
                        style="color:#999">待测量</span>
                </div>
              </div>
            </el-col>

            <el-col :span="4">
              <div class="grid-content ">
                <div class="details_title">
                  取件方式
                </div>
                <div class="details_content">
                  <span>{{orderID.fromtype }}</span>
                </div>
              </div>
            </el-col>

            <el-col :span="8">
              <div class="grid-content ">
                <div class="details_title">
                  下单时间
                </div>
                <div class="details_content">
                  <span>{{common.formatDate(orderID.createtime) }}</span>
                </div>
              </div>
            </el-col>

          </el-row>
        </div>
        <div class="orderShow_btn_control">
          <el-button type='primary'
                     size="mini"
                     v-if="orderID.status == 0"
                     @click="orderReview(orderID.id)">上门取件审核</el-button>
          <el-button type="primary"
                     size="mini"
                     @click="skipInvoice()">打印发票</el-button>
          <el-button type='primary'
                     size="mini"
                     @click="tabActiveGoodsInfo">物品列表</el-button>
          <el-button type='primary'
                     size="mini"
                     @click="showUploadFile">上传文件</el-button>
          <el-button type='primary'
                     size="mini"
                     @click="downloadFile"
                     v-if="downloadFile">下载已上传的文件</el-button>
        </div>

      </el-dialog>

      <el-dialog title="上传文件"
                 :visible.sync="upLoadingShow"
                 width="30%">
        <el-upload class="upload-demo"
                   :action="upUrl"
                   :multiple='false'
                   :data='{orderid:orderID.id}'
                   name='bgfile'
                   :limit='1'
                   :on-exceed="exceedFile"
                   :on-remove="removeFile"
                   :on-success="successUpload"
                   :accept='accept'>
          <el-button size="small"
                     type="primary">点击上传</el-button>
          <div slot="tip"
               class="el-upload__tip">根据需求上传报关或其他文件，详情请咨询客服。</div>
        </el-upload>
        <span slot="footer"
              class="dialog-footer">
          <el-button @click="upLoadingShow = false">取 消</el-button>
          <el-button type="primary"
                     @click="upLoadingShow = false">确 定</el-button>
        </span>
      </el-dialog>

      <!-- <el-dialog width="70%"
               title="物品列表"
               :visible.sync="dialogTableVisible_2"
               append-to-body>
      <el-table :data="activeGoodsInfo"
                style="width: 100%"
                stripe>
        <el-table-column label="ID"
                         width="50">
          <template slot-scope="scope">
            <span>{{ scope.$index+1 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="中文品名"
                         width="180"
                         height='50'>
          <template slot-scope="scope">
            {{scope.row.name}}
          </template>
        </el-table-column>
        <el-table-column label="英文品名"
                         width="180"
                         height='50'>
          <template slot-scope="scope">
            {{scope.row.enname?scope.row.enname:'无'}}
          </template>
        </el-table-column>
        <el-table-column label="货物类型"
                         width="150"
                         height='50'>
          <template slot-scope="scope">
            {{scope.row.wptype?scope.row.wptype:'未选择'}}
          </template>
        </el-table-column>
        <el-table-column label="数量"
                         width="80"
                         height='50'>
          <template slot-scope="scope">
            {{scope.row.num}}
          </template>
        </el-table-column>
        <el-table-column label="数量单位"
                         width="150"
                         height='50'>
          <template slot-scope="scope">
            {{scope.row.unit?scope.row.unit:'未选择'}}
          </template>
        </el-table-column>
        <el-table-column label="单价"
                         width="100"
                         height='50'>
          <template slot-scope="scope">
            {{scope.row.unitprice}}
          </template>
        </el-table-column>
        <el-table-column label="货币"
                         width="100"
                         height='50'>
          <template slot-scope="scope">
            {{scope.row.currencty}}
          </template>
        </el-table-column>
        <el-table-column label="总价值"
                         width="100"
                         height='50'>
          <template slot-scope="scope">
            {{scope.row.totalamount}}
          </template>
        </el-table-column>
      </el-table>
    </el-dialog> -->

      <el-dialog title="物品列表"
                 :visible.sync="dialogTableVisible_2">
        <el-table :data="activeGoodsInfo"
                  style="width: 100%">
          <el-table-column prop="name"
                           label="物品名"
                           width="100">
          </el-table-column>
          <el-table-column prop="enname"
                           label="英文品名"
                           width="100">
          </el-table-column>
          <el-table-column prop="num"
                           label="物品数量"
                           width="100">
          </el-table-column>
          <el-table-column prop="unitprice"
                           label="物品单价"
                           width="100">
          </el-table-column>
          <el-table-column prop="totalamount"
                           label="货物总价">
          </el-table-column>

        </el-table>
      </el-dialog>

      <!-- 订单审核 -->
      <el-dialog class="management_interface"
                 title="订单审核"
                 :visible="operationInterface.audit">

        <div class="orderPop"><span class="popTitle">取件时间 :</span><span class="orderReview_bar">{{orderID.qjstartime}}</span></div>
        <div class="orderPop"><span class="popTitle">联系人 :</span><span class="orderReview_bar">{{orderID.jjname+' '+orderID.jjmobile}}</span></div>
        <div class="orderPop"><span class="popTitle">取件地址 :</span><span class="orderReview_bar">{{orderID.jjprovince+' '+orderID.jjcity+' '+orderID.jjdistrict+' '+orderID.jjaddress}}</span></div>
        <div class="orderPop"><span class="popTitle">用户备注信息 :</span><span class="orderReview_bar">{{operationInterface.auditData.bak}}</span></div>
        <div class="orderPop">
          <el-form :model="operationInterface.bak"
                   ref="operationInterface"
                   label-width="130px"
                   class="collectDriver">

            <el-form-item label="取件司机姓名："
                          prop="name"
                          :rules="[
      { required: true, message: '司机姓名不能为空'},
      { min:2,max:10, message: '姓名长度2-10'}
    ]">
              <el-input v-model="operationInterface.bak.name"
                        placeholder="输入送件司机姓名"></el-input>
            </el-form-item>

            <el-form-item label="取件司机电话："
                          prop="mobile"
                          :rules="[
      { required: true, message: '司机联系方式不能为空'},
    ]">
              <el-input type='number'
                        v-model.number="operationInterface.bak.mobile"
                        placeholder="输入送件司机联系方式"></el-input>
            </el-form-item>

            <el-form-item label="取件车牌："
                          prop="plateNumber"
                          :rules="[
      { required: true, message: '取件车牌不能为空'},
    ]">
              <el-input v-model.number="operationInterface.bak.plateNumber"
                        placeholder="输入送件车辆的车牌号"></el-input>
            </el-form-item>
            <!-- <el-form-item>
    <el-button type="primary" @click="submitForm('numberValidateForm')">提交</el-button>
    <el-button @click="resetForm('numberValidateForm')">重置</el-button>
  </el-form-item> -->
          </el-form>
        </div>

        <span slot="footer"
              class="dialog-footer">
          <el-button @click="operationInterface.audit=false">取 消</el-button>
          <el-button type="danger"
                     @click="setIssue(orderID.id)">拒 绝</el-button>
          <el-button type="primary"
                     @click="confirmReview(orderID.id)">通 过</el-button>
        </span>
      </el-dialog>

      <!-- 设问题件 -->
      <el-dialog class="management_interface"
                 title="设问题件"
                 :visible.sync="operationInterface.issue">
        <div class="sj">
          <span>请说明问题原因:</span>
          <el-input v-model="operationInterface.issue_reason"
                    placeholder='请说明问题原因所在'></el-input>
        </div>
        <div class="sj"
             v-if="orderID.bgnum>1">
          <el-radio-group v-model="operationInterface.issue_boxNum"
                          size="mini">
            <el-radio-button :label="item"
                             v-for="item in orderID.bgnum"
                             :key="item">{{item}}号箱</el-radio-button>
          </el-radio-group>
        </div>
        <span slot="footer"
              class="dialog-footer">
          <el-button @click="operationInterface.issue=false">取 消</el-button>
          <el-button type="primary"
                     @click="confirmIssue(orderID.id)">通 过</el-button>
        </span>
      </el-dialog>

      <!-- 更改状态 -->
      <el-dialog class="management_interface"
                 title="更改状态"
                 :visible.sync="operationInterface.changeState">
        <div class="sj">
          <span>请选择要修改的状态:</span>
          <br>
          <el-select v-model="operationInterface.stateValue"
                     placeholder="选择要修改的状态">
            <el-option v-for="item in operationInterface.presentStateList"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="sj">
          <span>改变状态理由: </span>
          <el-input placeholder='请说明更改状态原因'
                    v-model="operationInterface.state_reason"></el-input>
        </div>
        <span slot="footer"
              class="dialog-footer">
          <el-button @click="operationInterface.changeState=false">取 消</el-button>
          <el-button type="primary"
                     @click="confirmChangeState(orderID.id)">通 过</el-button>
        </span>
      </el-dialog>

      <!-- 更改收货地址 -->
      <el-dialog class="management_interface"
                 @open='modificationOperationInterface'
                 title="更改收货地址"
                 :visible.sync="operationInterface.deliveryAddress">
        <div class="sj">
          <el-form :model="operationInterface"
                   label-width="100px">
            <el-form-item label="收件人姓名"
                          prop="deliveryAddress_name"
                          :rules="[ { required: true, message: '姓名不能为空'} ]">
              <el-input placeholder='请输入收件人姓名'
                        v-model="operationInterface.deliveryAddress_name"></el-input>
            </el-form-item>

            <el-form-item label="收件公司">
              <el-input placeholder='请输入收件公司'
                        v-model="operationInterface.deliveryAddress_sjcompanyname"></el-input>
            </el-form-item>
            <el-form-item label="公司税号">
              <el-input placeholder='请输入公司税号'
                        v-model="operationInterface.deliveryAddress_sjcompanytaxid"></el-input>
            </el-form-item>
            <el-form-item label="公司"
                          prop="deliveryAddress_mobile"
                          :rules="[ { required: true, message: '收件人电话'} ]">
              <el-input placeholder='请输入收件人联系电话'
                        v-model="operationInterface.deliveryAddress_mobile"></el-input>
            </el-form-item>

            <el-form-item label="地区信息"
                          :rules="[{ required: true, message: '改造费最低0元'}]">
              <el-cascader v-model="operationInterface.deliveryAddress_region"
                           :options="selectSiteOption"></el-cascader>
            </el-form-item>

            <el-form-item label="详细地址">
              <el-input placeholder='请输入收件人详细地址'
                        v-model="operationInterface.deliveryAddress_detailed"></el-input>
            </el-form-item>

            <el-form-item label="改址费"
                          prop="deliveryAddress_price"
                          :rules="[{ required: true, message: '改造费最低0元'}]">
              <el-input placeholder='本次改地址需要的费用，无费用为0'
                        v-model="operationInterface.deliveryAddress_price"></el-input>
            </el-form-item>

          </el-form>
        </div>
        <span slot="footer"
              class="dialog-footer">
          <el-button @click="operationInterface.deliveryAddress=false">取 消</el-button>
          <el-button type="primary"
                     @click="changeAaddress(orderID.id)">确 定</el-button>
        </span>
      </el-dialog>

      <!-- 添加转单号 -->
      <el-dialog title="添加转单号"
                 class="management_interface"
                 :visible.sync="operationInterface.trackingNumber">
        <div class="sj">
          <span>添加转单号 : </span>
          <br>
          <el-input placeholder="请输入转快递的单号"
                    v-model="operationInterface.oddNumberData"></el-input>
        </div>
        <div class="sj">
          <span>请选择快递公司:</span>
          <br>
          <el-select v-model="operationInterface.oddNumberKdnum"
                     placeholder="请选择快递公司">
            <el-option v-for="item in bePutInStorage.kdlist"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </div>
        <span slot="footer"
              class="dialog-footer">
          <el-button @click="operationInterface.trackingNumber = false">取 消</el-button>
          <el-button type="primary"
                     @click="changeOddNumber(orderID.id)">确 定</el-button>
        </span>
      </el-dialog>

      <!-- 添加附加费 -->
      <el-dialog title="添加附加费"
                 class="management_interface"
                 width="30%"
                 :visible.sync="operationInterface.additionalCharge">
        <div class="sj">
          <span>输入附加费金额 : </span>
          <br>
          <el-input placeholder="请输入附加费的金额(人民币)"
                    type="number"
                    v-model="operationInterface.additionalNumber"></el-input>
        </div>
        <div class="sj">
          <span>请说明附加费原因 : </span>
          <br>
          <el-input placeholder="请说明具体添加附加费理由"
                    v-model="operationInterface.additionalInfo"></el-input>
        </div>
        <span slot="footer"
              class="dialog-footer">
          <el-button @click="operationInterface.additionalCharge = false">取 消</el-button>
          <el-button type="primary"
                     @click="addSurcharge(orderID.id)">确 定</el-button>
        </span>
      </el-dialog>

      <!-- 设置订单签收 -->
      <el-dialog title="添加转单号"
                 class="management_interface"
                 :visible.sync="operationInterface.signFor">
        <div class="sj">
          <span>签收说明 : </span>
          <br>
          <el-input placeholder="请说明签收理由"
                    v-model="operationInterface.signForData"></el-input>
        </div>
        <div class="sj">
          <span v-if="orderID.bgnum>1">请现在签收的包裹</span>
          <el-checkbox-group v-if="orderID.bgnum>1"
                             v-model="operationInterface.signForNumber">
            <el-checkbox-button v-for="item in  parseInt(orderID.bgnum)"
                                :label="item"
                                :key="item">{{item}}</el-checkbox-button>
          </el-checkbox-group>
        </div>
        <span slot="footer"
              class="dialog-footer">
          <el-button @click="operationInterface.signFor = false">取 消</el-button>
          <el-button type="primary"
                     @click="signForOrder(orderID.id)">确 定</el-button>
        </span>
      </el-dialog>

      <!-- 转运状态 -->
      <el-dialog class="management_interface"
                 title="转运状态"
                 :visible.sync="operationInterface.transferSet">
        <div class="sj">
          <span>请输入转运的目的地</span>
          <el-input placeholder='请输入转运的目的地'
                    v-model="operationInterface.transferSite"></el-input>
        </div>
        <div class="sj">
          <span>请备注转运的备注</span>
          <el-input placeholder='请输入转运备注'
                    v-model="operationInterface.signForInfo"></el-input>
        </div>
        <span v-if="orderID.bgnum>1">请选择签收的</span>
        <el-checkbox-group v-if="orderID.bgnum>1"
                           v-model="operationInterface.transfer_bgnum">
          <el-checkbox-button v-for="item in  parseInt(orderID.bgnum)"
                              :label="item"
                              :key="item">{{item}}</el-checkbox-button>
        </el-checkbox-group>
        <span slot="footer"
              class="dialog-footer">
          <el-button @click="operationInterface.transferSet = false">取 消</el-button>
          <el-button type="primary"
                     @click="transferState(orderID.id)">确 定</el-button>
        </span>
      </el-dialog>

      <!-- 派送状态 -->
      <el-dialog class="management_interface"
                 title="派送状态"
                 :visible.sync="operationInterface.delivery">
        <div class="sj">
          <span>派送说明</span>
          <el-input placeholder='请填写派送说明备注'
                    v-model="operationInterface.deliveryRemark"></el-input>
        </div>
        <div class="sj"
             v-if="orderID.bgnum>1">
          <span>请选择派送的箱号</span>
          <el-checkbox-group v-model="operationInterface.deliveryNumber">
            <el-checkbox-button v-for="item in  parseInt(orderID.bgnum)"
                                :label="item"
                                :key="item">{{item}}</el-checkbox-button>
          </el-checkbox-group>
        </div>
        <span slot="footer"
              class="dialog-footer">
          <el-button @click="operationInterface.delivery = false">取 消</el-button>
          <el-button type="primary"
                     @click="orderDelivery(orderID.id)">确 定</el-button>
        </span>
      </el-dialog>

      <!-- 退货状态 -->
      <el-dialog class="management_interface"
                 title="退货状态"
                 :visible.sync="operationInterface.salesReturn">
        <div class="sj">
          <span>备注说明</span>
          <el-input placeholder='请填写退货状态说明备注'
                    v-model="operationInterface.rejectionExplain"></el-input>
        </div>
        <div class="sj">
          <span>退货运费金额</span>
          <el-input placeholder='请填写退货需要的运费金额(人民币)'
                    type="number"
                    v-model="operationInterface.tuiheprice"></el-input>
        </div>
        <div class="sj">
          <span>退货联系人</span>
          <el-input placeholder='请填写退货联系人姓名'
                    v-model="operationInterface.thName"></el-input>
        </div>
        <div class="sj">
          <span>联系电话</span>
          <el-input placeholder='请填写退货联系电话'
                    v-model="operationInterface.thMobile"></el-input>
        </div>

        <div class="sj">
          <span>退货国家</span>
          <el-input placeholder='请填写退货国家'
                    v-model="operationInterface.thGuojia"></el-input>
        </div>

        <div class="sj">
          <span>详细地址</span>
          <el-input placeholder='请填写退货详细地址'
                    v-model="operationInterface.thAddress"></el-input>
        </div>

        <div class="sj"
             v-if="orderID.bgnum>1">
          <span>恢复状态</span>
          <el-select v-model="operationInterface.thstatus"
                     filterable
                     placeholder="请选择">
            <el-option v-for="(item,index) in orderID.zttype"
                       :key="index"
                       :label="item"
                       :value="index">
            </el-option>
          </el-select>
        </div>

        <div class="sj">
          <span>产品是否在仓库</span>
          <br />
          <el-radio v-model="operationInterface.ck"
                    label="1"
                    border>货物仍在仓</el-radio>
          <el-radio v-model="operationInterface.ck"
                    label="0"
                    border>货物已出仓</el-radio>
        </div>
        <!--  -->

        <div class="sj"
             v-if="orderID.bgnum>1">
          <span>请选择退货的箱号</span>
          <el-checkbox-group v-model="operationInterface.rejectionbg">
            <el-checkbox-button v-for="item in  parseInt(orderID.bgnum)"
                                :label="item"
                                :key="item">{{item}}</el-checkbox-button>
          </el-checkbox-group>
        </div>
        <span slot="footer"
              class="dialog-footer">
          <el-button @click="operationInterface.salesReturn = false">取 消</el-button>
          <el-button type="primary"
                     @click="orderRejected(orderID.id)">确 定</el-button>
        </span>
      </el-dialog>

      <!-- 拒收状态-->
      <el-dialog class="management_interface"
                 title="拒收设置"
                 :visible.sync="operationInterface.rejection">
        <div class="sj">
          <span>备注说明</span>
          <el-input placeholder='请填写拒收状态说明备注'
                    v-model="operationInterface.salesReturnExplain"></el-input>
        </div>
        <div class="sj"
             v-if="orderID.bgnum>1">
          <span>请选择拒收的箱号</span>
          <el-checkbox-group v-model="operationInterface.salesReturnBg">
            <el-checkbox-button v-for="item in  parseInt(orderID.bgnum)"
                                :label="item"
                                :key="item">{{item}}</el-checkbox-button>
          </el-checkbox-group>
        </div>
        <span slot="footer"
              class="dialog-footer">
          <el-button @click="operationInterface.rejection = false">取 消</el-button>
          <el-button type="primary"
                     @click="orderSalesReturn(orderID.id)">确 定</el-button>
        </span>
      </el-dialog>

      <el-dialog title="导出Excle文件"
                 :visible.sync="isExportExcel"
                 @close='tableShowData.operation = true'
                 class="exportExcle">
        <span><i class='el-icon-warning-outline'
             style="color:#F56C6C"></i> 导出内容为管理订单所展示的内容,已为您自动隐藏了操作按钮</span>
        <div class="exportExcle_excelName">
          <span>请输入文件名: </span>
          <el-input v-model="excelName"
                    placeholder="请输入内容"
                    size="mini"></el-input>
          <span>.xlsx</span>
        </div>
        <div slot="footer"
             class="dialog-footer">
          <el-button type='primary'
                     @click="exportExcel(false)">导出所有</el-button>
          <el-button type="primary"
                     @click="CheckboxExportExcel"
                     v-loading.fullscreen.lock="fullscreenLoading">导出选中</el-button>
        </div>
      </el-dialog>
    </div>

  </div>
</template>

<script>
import editOrder from '@/components/editOrder.vue'
import { apiChangeAddess, apiZHCN, apiManageOrders, apiRejection, apiSalesReturn, apiTransferSet, apiDelivery, apiSignFor, apiAdditionalCharge, apiAddOdd, apiOffer, apiSite, apiIssue, apiOrderDetails, apiChangeState, apiRemoveOrders, apiAudit, apiRefuse } from '@/request/api'
import FileSaver from 'file-saver'
import XLSX from 'xlsx'
import common from '@/assets/js/common'
export default {
  name: "AllOrders",
  data () {
    return {
      //--------计费重--------
      priceWeight: '',
      upUrl: '',
      //--------需要修改的订单id--------
      orderData: '',
      //--------修改显示--------
      edit_show: false,
      //--------下载报关文件--------
      downloadUrl: '',
      //----------------
      updataOrderId: '',
      //--------限制上传文件--------
      accept: '.xls, .xlsx, .csv',
      //--------上传数据--------
      uploadData: {},
      //是否显示上传
      upLoadingShow: false,
      //订单类型选择器
      selectTypeOption: [{ label: '集运', value: 2 }, { label: '商业件', value: 1 }],
      //地址选择器
      selectSiteOption: [],
      //调用公用方法
      common,
      //订物品单数量
      activeGoodsInfo: [],
      //储存所有快递100信息数据
      allKD100: '',
      //是否为第一次访问订单详情
      forTheFirstTime: true,
      // 入库操作
      bePutInStorage: {
        orderID: '',
        bgnum: 1,
        isClick: true,
        activeData: {
          kdnum: ''
        },
        flag: true,
        tableData: [
          {
            chang: '',
            kuan: '',
            gao: '',
            weight: '',
            tj: '',
            zdnum: ''
          }
        ],
        show: false,
        isShow: false,
        kdname: '',
        kdlist: [
          {
            value: 'dhl',
            label: 'DHL'
          },
          {
            value: 'fedex',
            label: 'FedEx'
          },
          {
            value: 'tnt',
            label: 'TNT'
          },
          {
            value: 'ups',
            label: 'UPS'
          },
          {
            value: 'fedexus',
            label: 'fedex美国'
          },
          {
            value: 'usps',
            label: 'usps'
          },
          {
            value: 'ems',
            label: 'EMS国际'
          },
          {
            value: 'japanpost',
            label: '日本邮政'
          },
          {
            value: 'hkpost',
            label: '香港邮政'
          },
          {
            value: 'royalmail',
            label: '英国邮政'
          },
          {
            value: 'auspost',
            label: '澳大利亚邮政'
          },
        ],
      },
      // 订单详情操作按钮
      operationInterface: {
        //订单审核
        audit: false,
        auditData: '',
        sjID: 0,
        bak: {
          name: '',
          mobile: '',
          plateNumber: ''
        },
        //设问题件
        issue: false,
        issue_reason: '',
        issue_boxNum: 1,
        //更改状态
        changeState: false,
        stateValue: '',
        presentStateList: [],
        state_reason: '',
        //更改收货地址
        deliveryAddress: false,
        deliveryAddress_gj: false,
        deliveryAddress_gjID: '',
        deliveryAddress_bjList: '',
        deliveryAddress_bjID: '',
        deliveryAddress_name: '',
        deliveryAddress_mobile: '',
        deliveryAddress_detailed: '',
        deliveryAddress_sjcompanytaxid: '',
        deliveryAddress_sjcompanyname: '',
        deliveryAddress_price: 0,
        deliveryAddress_region: [],
        //添加转单号
        trackingNumber: false,
        oddNumberData: '',
        oddNumberKdnum: '',
        //添加附加费
        additionalCharge: false,
        additionalNumber: '',
        additionalInfo: '',
        //订单签收
        signFor: false,
        signForData: '',
        signForNumber: [],
        signForInfo: '',
        //转运状态
        transferSet: false,
        transferSite: '',
        transfer_bgnum: [],
        //派件状态设置
        delivery: false,
        deliveryRemark: '',
        deliveryNumber: '',
        //退货设置
        salesReturn: false,
        rejectionExplain: '',
        rejectionbg: '',
        tuiheprice: '',
        thName: '',
        thMobile: '',
        thGuojia: '',
        thAddress: '',
        thstatus: '',
        ck: '1',
        //拒收设置
        rejection: false,
        salesReturnExplain: '',
        salesReturnBg: '',
      },
      //加载
      fullscreenLoading: false,
      // 用户选择的数据
      exportExcelData: [],
      //要导出的excel表格
      exportTable: 'main_table',
      //是否显示导出文件详情
      isExportExcel: false,
      //导出的excel文件名
      excelName: '团运订单',
      //当前页数
      currentPage: 1,
      // 显示分页选择
      pageSizeArr: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 200, 300, 400, 999],
      //一页显示列表数目
      pageSize: 10,
      //是否为第一次加载
      oneLoad: true,
      //存储原数据
      sourceData: {},
      //隐藏已取消
      isShowCancel: true,
      // 是否显示选择框
      isCheckbox: false,
      // 是否显示表边框
      isTabelBorder: false,
      //弹框展示内容
      exhibitionData: false,
      // 表格显示内容
      tableShowData: {
        wlnum: true,
        zt: true,
        addrid: true,
        kdnum: true,
        sjname: true,
        ckid: true,
        operation: true,

        //订单id
        id: false,
        //订单公众号id
        // uniacid:true
        //渠道
        cid: false,
        //报价
        bjinfo: false,
        //总重量
        weight: false,
        //总体积
        tj: false,
        //送件类型
        ofromtype: false,

        //付款类型
        paytype: false,
        //手续费
        feeprice: false,
        //代收款金额
        dsprice: false,
        //改签地址费用
        gqprice: false,
        //订单总价
        allprice: false,

        //寄件人电话
        jjmobile: false,
        //寄件人姓名
        jjname: false,
        //寄件人省份
        jjprovince: false,
        //寄件人城市
        jjcity: false,
        //寄件人街道
        jjdistrict: false,
        //寄件人邮编
        jjzipcode: false,
        //寄件人详细地址
        jjaddress: false,

        //收件人电话
        sjmobile: false,
        //收件人省份
        sjprovince: false,
        //收件人城市
        sjcity: false,
        //收件人区域
        sjdistrict: false,
        //收件人邮编
        sjzipcode: false,
        //收件人详细地址
        sjaddress: false,

        //包裹数量（箱数）
        bgnum: false,
        //转运单号
        zynum: false,
        //快递公司
        // kdname: false,
        //转运仓库ID
        zyckid: false,

        //取件开始时间
        qjstartime: false,
        //取件结束时间
        qjendtime: false,
        //取件司机用户ID
        qjuid: false,
        //取件备注信息
        qjbzinfo: false,
        //推介人ID
        tjuid: false,
        //订单创建时间
        createtime: false,
        //更新时间
        edittime: false,
        //订单备注
        info: false,

      },
      //搜索是否显示更多
      search: 50,
      search_flag: true,
      //时间
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now() - 8.64e7;
        }
      },
      //送件方式
      fromtype: [
        {
          label: '自寄',
          value: '1'
        }, {
          label: '上门',
          value: '2'
        }, {
          label: '自送',
          value: '3'
        }
      ],
      //渠道方案列表
      qdlist: '',
      //报价方案列表
      bjlist: '',
      //状态
      zt: '',
      //当前订单状态
      statusID: 0,
      //当前显示的订单详情内容
      orderID: '',
      //是否显示订单详情
      dialogTableVisible: false,
      dialogTableVisible_2: false,
      //加载动画
      loading: false,
      //判断翻页状态
      pageStatus: 1,
      //当前页
      page: 1,
      //订单数量
      ordernum: 1,
      //订单列表
      tableData: [],
      //订单状态数组
      orderStatus: [],
      //仓库数据
      warehouseChoose: [],
      // 国家和城市列表
      prop: {
        lazy: true,
        options: [],
        lazyLoad (node, resolve) {
          apiSite().then(res => {
            //初始化
            if (node.level === 0) {
              let arr = []
              //处理数据
              Object.keys(res.gjlist).forEach(key => {
                arr.push(res.gjlist[key])
              })
              let nodes = []
              for (const key in arr) {
                if (arr[key].province) {
                  if (arr[key].province.length > 1) {
                    let newArr = {
                      value: arr[key].id,
                      label: arr[key].label,
                      childre: arr[key].province
                    }
                    nodes.push(newArr)
                  } else if (arr[key].province.length === 1) {
                    let newArr = {
                      value: arr[key].id,
                      label: arr[key].label,
                      childre: arr[key].province[0].city
                    }
                    nodes.push(newArr)
                  } else {
                    let newArr = {
                      value: arr[key].id,
                      label: arr[key].label,
                      childre: arr[key].province[0].city
                    }
                    nodes.push(newArr)
                  }
                }
              }
              this.options = nodes
            } if (node.level === 1) {
              if (node.data.childre.length > 1) {
                this.options = node.data.childre.map(item => ({
                  value: item.label,
                  label: item.label,
                  childre: item.city ? item.city : null,
                  leaf: item.city ? false : true,
                }))
              } else {
                this.options = node.data.childre[0].city.map(item => ({
                  value: item.label,
                  label: item.label,
                  childre: item.city,
                  leaf: true
                }))
              }
            } if (node.level === 2) {
              this.options = node.data.childre.map(item => ({
                value: item.label,
                label: item.label,
                leaf: true
              }))
            }
            resolve(this.options)
          })
        }
      },

      // 国家查询数据
      props: {
        lazy: true,
        options: [],
        lazyLoad (node, resolve) {
          apiSite().then(res => {
            //初始化
            if (node.level === 0) {
              let arr = []
              //处理数据
              Object.keys(res.gjlist).forEach(key => {
                arr.push(res.gjlist[key])
              })
              let nodes = []
              for (const key in arr) {
                if (arr[key].province) {
                  if (arr[key].province.length > 1) {
                    let newArr = {
                      value: arr[key].id,
                      label: arr[key].label,
                      leaf: true
                    }
                    nodes.push(newArr)
                  }
                }
              }
              this.options = nodes
            }
            resolve(this.options)
          })
        }
      },
      // 查询条件
      queryCondition: {
        // 查询状态
        selectType: '',
        // 订单状态
        status: '',
        // 国家id
        addrid: '',
        // 仓库id
        ckid: '',
        //物流单号
        wlnum: '',
        //快递单号
        kdnum: '',
        //收件人姓名
        keyword: '',
        //报价id
        bjID: '',
        //渠道id
        qdID: '',
        //送件方式
        fromtype: '',
        //用户id
        uid: '',
        // 推荐用户id
        tjuid: '',
        //订单时间
        ordertime: {
          start: '',
          end: ''
        }
      }
    }
  },
  methods: {
    //  -----------修改值-----------
    onChange (e) {
      this.edit_show = e
    },
    //  -----------下载报关文件-----------
    downloadFile () {
      location.href = this.downloadUrl
    },
    //  -----------上传成功回调-----------
    successUpload (e) {
      this.uploadData = e
      this.downloadUrl = e.fileurl
      this.$message(e.message)
      this.upLoadingShow = false
    },
    //  -----------移除文件-----------
    removeFile (e) {
      this.$message.success('成功移除' + e.name + '文件')

    },
    //  -----------超出提醒-----------
    exceedFile (e) {
      this.$message.error('您已经上传了' + e[0].name + '文件,请先删除。')
    },
    // -----------显示上传文件-----------
    showUploadFile (id) {
      this.updataOrderId = id
      this.upLoadingShow = true
    },
    // ----------获取地址数据----------
    async refuseOrder (orderid) {
      let res = await apiRefuse({
        op: 'noqs',
        orderid,

      })
    },
    // ----------获取地址数据----------
    async getSiteData () {
      let arr = []
      let res = await apiZHCN({
      })
      for (const key in res.gjlist) {
        if (res.gjlist[key].value == this.orderID.addrid) {
          arr.push(res.gjlist[key])
        }
      }
      this.selectSiteOption = arr
      //   common.
      console.log(arr);
    },
    // ----------更改地址----------
    async changeAaddress (id) {
      let res = await apiChangeAddess({
        orderid: id,
        gqprice: this.operationInterface.deliveryAddress_price,
        gj: this.operationInterface.deliveryAddress_region[0],
        address: JSON.stringify({
          username: this.operationInterface.deliveryAddress_name,
          mobile: this.operationInterface.deliveryAddress_mobile,
          province: this.operationInterface.deliveryAddress_region[1],
          city: this.operationInterface.deliveryAddress_region[2],
          district: this.operationInterface.deliveryAddress_region[3],
          address: this.operationInterface.deliveryAddress_detailed,
        }),
        sjcompanytaxid: this.operationInterface.deliveryAddress_sjcompanytaxid,
        sjcompanyname: this.operationInterface.deliveryAddress_sjcompanyname,
        pd: "ok"
      })
      if (res.errno == 1) {
        this.$notify.error({
          title: '错误',
          message: res.message
        });
      } else {
        this.$notify({
          title: '成功',
          message: res.message
        });
        this.operationInterface.deliveryAddress = false
      }
    },
    //----------把用户的收件地址赋值上去----------
    modificationOperationInterface () {
      this.operationInterface.deliveryAddress_name = this.orderID.sjname
      this.operationInterface.deliveryAddress_mobile = this.orderID.sjmobile
      this.operationInterface.deliveryAddress_detailed = this.orderID.sjaddress
      this.operationInterface.deliveryAddress_sjcompanyname = this.sjcompanyname
      this.operationInterface.deliveryAddress_sjcompanytaxid = this.sjcompanytaxid
      this.operationInterface.deliveryAddress_region = []
      this.operationInterface.deliveryAddress_region.push(this.orderID.addrid, this.orderID.sjprovince, this.orderID.sjcity)
      this.getSiteData()
    },

    // ----------修改物品为当前选择的----------
    tabActiveGoodsInfo () {
      this.dialogTableVisible_2 = true
      this.activeGoodsInfo = []
      for (const key in this.orderID.xz_weight_tj) {
        for (const k in this.orderID.xz_weight_tj[key].wpinfo) {
          this.activeGoodsInfo.push(this.orderID.xz_weight_tj[key].wpinfo[k])
        }
      }
    },

    //跳转打印发票页面
    skipInvoice () {
      this.fullscreenLoading = true;
      this.$router.push(
        {
          name: 'Invoice',
          query: {
            id: this.orderID.id
          }
        }
      )
      this.fullscreenLoading = false;

    },
    //添加认领订单
    claimOrder () {
      this.bePutInStorage.isClick = false
      this.bePutInStorage.isShow = true
      this.bePutInStorage.activeData.kdnum = this.queryCondition.kdnum
      if (this.allKD100 == '') {
        this.orderIDdetails()
      }
    },

    //订单拒收
    async orderSalesReturn (id) {
      this.fullscreenLoading = true;

      let res = await apiRejection({
        orderid: id,
        info: this.operationInterface.salesReturnExplain,
        bgnum: this.operationInterface.salesReturnBg,
      })
      this.isSuccess(res.errno, res.message, () => {
        this.operationInterface.rejection = false
        this.resetData()
      })
      this.fullscreenLoading = false;

    },
    //订单退货
    async orderRejected (id) {

      if (this.operationInterface.rejectionExplain == '') {
        return this.$message.error('请填写退货备注说明')
      } else if (this.operationInterface.tuiheprice == '') {
        return this.$message.error('请填写退货价格')
      } else if (this.operationInterface.thName == '') {
        return this.$message.error('请填写退货人姓名')
      } else if (this.operationInterface.thMobile == '') {
        return this.$message.error('请填写退货人联系方式')
      } else if (this.operationInterface.thGuojia == '') {
        return this.$message.error('请填写退货目的国家')
      } else if (this.operationInterface.thAddress == '') {
        return this.$message.error('请填写退货的详细地址')
      }

      this.fullscreenLoading = true;
      let res = await apiSalesReturn({
        orderid: id,
        info: this.operationInterface.rejectionExplain,
        bgnum: this.operationInterface.rejectionbg,
        tuiheprice: this.operationInterface.tuiheprice,
        hfstatus: this.operationInterface.thstatus,
        gjid: this.operationInterface.thGuojia,
        sjname: this.operationInterface.thName,
        sjmobile: this.operationInterface.thMobile,
        sjaddress: this.operationInterface.thAddress,
        ck: this.operationInterface.ck,
      })
      if (res.errno == 0) {
        this.$confirm('退货详细提交成功,是否需要打印退货单?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'success'
        })
          .then(() => {
            this.$router.push({
              name: 'Invoice',
              params: {
                tuiheinfo: res.tuiheinfo,
                type: 'returnGoods',
                thtype: res.thtype
              }
            })
          })
          .catch(() => {
            this.isSuccess(res.errno, res.message, () => {
              this.operationInterface.salesReturn = false
              this.resetData()
            })
          });
      } else {
        this.$notify.error({
          title: '错误',
          message: res.message
        });
      }

      this.fullscreenLoading = false;

    },
    //订单派送
    async orderDelivery (id) {
      this.fullscreenLoading = true;
      let res = await apiDelivery({
        orderid: id,
        info: this.operationInterface.deliveryRemark,
        bgnum: this.operationInterface.deliveryNumber
      })
      this.isSuccess(res.errno, res.message, () => {
        this.operationInterface.delivery = false
        this.resetData()
      })
      this.fullscreenLoading = false;
    },
    //转运状态
    async transferState (id) {
      this.fullscreenLoading = true;
      let res = await apiTransferSet({
        orderid: id,
        place: this.operationInterface.additionalNumber,
        info: this.operationInterface.signForInfo,
        bgnum: this.operationInterface.transfer_bgnum
      })
      this.isSuccess(res.errno, res.message, () => {
        this.operationInterface.transferSet = false
        this.resetData()
      })
      this.fullscreenLoading = false;
    },
    //订单签收
    async signForOrder (id) {
      this.fullscreenLoading = true;
      let res = await apiSignFor({
        orderid: id,
        info: this.operationInterface.signForData,
        bgnum: this.operationInterface.signForNumber
      })
      this.isSuccess(res.errno, res.message, () => {
        this.operationInterface.signFor = false
        this.resetData()
      })
      this.fullscreenLoading = false;
    },
    //添加附加费
    async addSurcharge (id) {
      this.fullscreenLoading = true;
      let res = await apiAdditionalCharge({
        orderid: id,
        otherprice: this.operationInterface.additionalNumber,
        otherpriceinfo: this.operationInterface.additionalNumber
      })
      this.isSuccess(res.errno, res.message, () => {
        this.operationInterface.additionalCharge = false
        this.resetData()
      })
      this.fullscreenLoading = false;
    },
    //更改转单号
    async changeOddNumber (id) {
      this.fullscreenLoading = true;
      let res = await apiAddOdd({
        orderid: id,
        zynum: this.operationInterface.oddNumberData,
        kdname: this.operationInterface.oddNumberKdnum
      })
      console.log(res);
      this.isSuccess(res.errno, res.message, () => {
        this.operationInterface.trackingNumber = false
        this.resetData()
      })
      this.fullscreenLoading = false;
    },
    //获取国家下的报价
    async gjOffe (e) {
      if (!e) {
        let _this = this
        setTimeout(function () {
          apiOffer({
            gjid: _this.operationInterface.deliveryAddress_gjID[0],
            province: _this.operationInterface.deliveryAddress_gjID[1],
            city: _this.operationInterface.deliveryAddress_gjID[2],
            weight: _this.orderID.weight,
            tj: _this.orderID.tj,
            pageSize: 999
          })
            .then(res => {
              _this.operationInterface.deliveryAddress_bjList = res.allbj
              _this.operationInterface.deliveryAddress_bjID = ''
            })
        }, 1)
      }
    },
    //确定更改当前状态
    async confirmChangeState (id) {
      this.fullscreenLoading = true;
      if (this.operationInterface.stateValue === '') {
        this.$notify.error({
          title: '错误',
          message: '请选择更改的状态'
        });
        return
      } else if (this.operationInterface.state_reason === '') {
        this.$notify.error({
          title: '错误',
          message: '请输入更改的理由'
        });
        return
      }
      let res = await apiChangeState({
        pd: 'ok',
        orderid: id,
        info: this.operationInterface.state_reason,
        status: this.operationInterface.stateValue
      })
      this.isSuccess(res.errno, res.message, () => {
        this.resetData()
        this.dialogTableVisible = false
        this.operationInterface.changeState = false
      })
      this.fullscreenLoading = false;
    },
    // 读取当前订单对应状态列表
    async readStateList (id) {
      this.fullscreenLoading = true;
      let res = await apiChangeState({
        pd: 'getzt',
        orderid: id
      })
      this.operationInterface.presentStateList = res.ztlist
      this.operationInterface.changeState = true
      this.fullscreenLoading = false;
    },
    //
    setIssue (id) {
      this.$prompt('请输入拒绝理由', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(({ value }) => {
        this.operationInterface.issue_reason = value
        this.confirmIssue(id)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消输入'
        });
      });
    },
    //确定设置问题件
    async confirmIssue (id) {

      this.fullscreenLoading = true;
      if (this.operationInterface.issue_reason === '') {
        this.$notify.error({
          title: '错误',
          message: '请输入问题理由'
        });
      }
      let res = await apiIssue({
        orderid: id,
        info: this.operationInterface.issue_reason,
        pd: 'ok',
        bgnum: this.operationInterface.issue_boxNum
      })
      if (res.errno == 0) {
        this.operationInterface.issue = false
        this.$notify.success({
          title: '成功',
          message: res.message
        });
        this.resetData()
        this.operationInterface.audit = false

        this.dialogTableVisible = false
      } else {
        this.$notify.error({
          title: '错误',
          message: res.message
        });
      }
      this.fullscreenLoading = false;

    },
    //确定审核订单
    async confirmReview (id) {
      this.fullscreenLoading = true;
      this.$refs.operationInterface.validate((valid) => {
        if (valid) {
          this.$confirm('确定通过上门取件吗', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(async () => {
            this.fullscreenLoading = true;
            let res = await apiAudit({
              orderid: id,
              pdd: 'ok',
              bak: `司机姓名：${this.operationInterface.bak.name} <br/>司机电话：${this.operationInterface.bak.mobile} <br/>车牌号：${this.operationInterface.bak.plateNumber} <br/>`,
              qjuid: 0
            })

            if (res.errno === 0) {
              this.resetData()
              this.$notify.success({
                title: '成功',
                message: res.message
              });
              this.$nextTick(() => {
                this.operationInterface.audit = false
                this.fullscreenLoading = false
                this.dialogTableVisible = false
              })
            } else {
              this.$notify.error({
                title: '错误',
                message: res.message
              });
            }
          }).catch(() => {
          });
        } else {
          this.fullscreenLoading = false;
          return false;
        }
      });
      this.fullscreenLoading = false;
    },
    //读取订单审核
    async orderReview (id) {
      this.fullscreenLoading = true;
      this.operationInterface.audit = true
      let res = await apiAudit({
        orderid: id
      })

      this.operationInterface.auditData = res
      this.operationInterface.auditData.sjlist = common.transform(this.operationInterface.auditData.sjlist)

      this.fullscreenLoading = false;
    },

    //封装返回数据成功或失败
    isSuccess (flag, message, callback) {
      if (flag == 0) {
        if (callback) {
          callback()

        }
        this.$notify.success({
          title: '成功',
          message
        });
      } else {
        this.$notify.error({
          title: '错误',
          message
        });
      }
    },

    //选中行数据储存
    storeData (e, r) {
      this.exportExcelData = null
      if (this.isCheckbox) {
        this.exportExcelData = e
      }
    },
    //导出选中excel
    CheckboxExportExcel () {
      if (this.isCheckbox && this.exportExcelData[0]) {
        this.fullscreenLoading = true;
        let data = this.tableData
        let _this = this
        this.tableData = this.exportExcelData
        setTimeout(function () {
          _this.exportExcel(data)
        }, 1000)
      } else {
        this.$notify.error({
          title: '错误',
          message: '您还没有选择数据呢'
        });
        this.tableShowData.operation = true
        this.isExportExcel = false
      }

    },

    //导出excel
    exportExcel (data) {
      this.fullscreenLoading = true;
      //表名
      var wb = XLSX.utils.table_to_book(document.querySelector(`#${this.exportTable}`))
      /* get binary string as output */
      var wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' })
      try {
        FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), `${this.excelName}.xlsx`)
      } catch (e) { if (typeof console !== 'undefined') console.log(e, wbout) }
      this.$notify({
        title: '导出成功',
        message: '已为你导出excel文件',
        type: 'success'
      });
      this.isExportExcel = false
      if (data) {
        this.tableData = data
      }
      this.fullscreenLoading = false;
      this.tableShowData.operation = true
      return wbout
    },

    //更改单页显示数量
    async handleChange (e) {
      this.pageSize = e
      let res = await apiManageOrders({
        op: 'list',
        pd: 'getlist',
        page: this.page,
        pageSize: this.pageSize
      })
      this.tableData = common.transform(res.orderlist)
      this.sourceData = ''
      this.concealOrder()
      this.ordernum = parseInt(res.totalNum)
    },
    //显示已取消订单
    concealOrder (e) {
      if (e || this.isShowCancel) {
        // 创建一个空数组
        let arr = []
        // 储存原来的所有数据
        this.sourceData = this.tableData
        //循环拿到所有非已取消的订单
        for (const key in this.tableData) {
          if (this.tableData[key].status != -1) {
            // 把所有非已取消的订单添加到arr数组
            arr.push(this.tableData[key])
          }
        }
        // 把arr赋值给tableData
        this.tableData = arr
        //关闭第一次加载
        this.oneLoad = false
      } else if (this.sourceData != '') {
        this.tableData = this.sourceData
      }
    },
    //取消订单
    cancellationOrder (id, reason) {
      apiRemoveOrders({
        listoid: id,
        info: reason.value
      })
        .then(res => {

          this.$router.go(0);
          Message.success(res.message)
          return res
        })
    },
    //取消订单确认
    removeOrder (id) {
      this.$prompt('取消理由', '您真的要取消订单吗?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPlaceholder: '请输入取消理由'
      })
        .then(res => {
          this.cancellationOrder(id, res)
        })
        .catch(err => {
          Message.error('取消失败,错误信息:' + err)
        })
    },
    //展开更多|收起更多
    moreClick (e) {
      if (this.search_flag) {
        this.search = 150
        this.search_flag = false
      } else {
        this.search = 50
        this.search_flag = true
      }
    },
    //订单时间补充
    timeReplenish () {
      let dataTime = new Date()
    },
    //处理货币
    currenctyDate (ab) {
      switch (ab) {
        case 'RUB':
          return '俄罗斯卢布'
          break;
        case 'AUD':
          return '澳大利亚元'
          break;
        case 'NLG':
          return '荷兰盾'
          break;
        case 'GBP':
          return '英镑'
          break;
        case 'FRF':
          return '法郎'
          break;
        case 'INR':
          return '印度卢比'
          break;
        case 'EUR':
          return '欧元'
          break;
        case 'CNY':
          return '人民币'
          break;
        case 'USD':
          return '美元'
          break;
        case 'VND':
          return '越南盾'
          break;
        case 'MOP':
          return '新加坡元'
          break;
        case 'JPY':
          return '日元'
          break;
        case 'KRW':
          return '韩元'
          break;
        case 'MYR':
          return '马币'
          break;
        case 'NTD':
          return '台币'
          break;
        case 'HKD':
          return '港币'
          break;
        default:
          break;
      }
    },
    //处理订单状态
    orderStatusID (id) {
      id = parseInt(id)
      if (id == 0) {
        return this.statusID = 0
      } else if (id <= 3 && id > 0) {
        return this.statusID = 1
      } else if (id <= 6 && id > 3) {
        return this.statusID = 2
      } else if (id <= 8 && id > 6) {
        return this.statusID = 3
      } else if (id <= 10 && id > 9) {
        return this.statusID = 4
      } else if (id >= 11) {
        return this.statusID = 5
      }
    },
    //查看订单详情
    async orderIDdetails (row, flag) {
      let res = await apiOrderDetails({
        op: 'orderinfo',
        pd: 'getinfo',
        orderid: row ? row.id : '',
        getkd100: row ? this.forTheFirstTime && (row.status == 8 || (row.status > 0 && row.status < 3)) ? 1 : '' : 1
      })
      if (res.errno != 1) {
        this.orderID = res
        this.downloadUrl = this.orderID.bgfile
        this.orderID.qjstartime = common.formatDate(this.orderID.qjstartime)
        this.priceWeight = 0
        if (res.xz_weight_tj) {
          for (const key in res.xz_weight_tj) {
            this.priceWeight += parseFloat(res.xz_weight_tj[key].jfz)
          }
        }

        if (!flag) {
          this.dialogTableVisible = true
        }
        if (this.forTheFirstTime) {
          this.allKD100 = res.kd100
          this.forTheFirstTime = false
        }
      } else {
        Message.error(res.message)
      }
      if (!row) {
        this.allKD100 = res.kd100
      }
    },
    //修改订单
    modifyOrder (row) {
      this.orderData = row.id
      this.edit_show = true
    },
    //清除数据
    resetData () {
      this.queryCondition = {
        // 订单状态
        status: '',
        // 国家id
        addrid: '',
        // 仓库id
        ckid: '',
        //物流单号
        wlnum: '',
        //快递单号
        kdnum: '',
        //收件人姓名
        keyword: '',
        //报价id
        bjID: '',
        //渠道id
        qdID: '',
        //送件方式
        fromtype: '',
        //用户id
        uid: '',
        // 推荐用户id
        tjuid: '',
        // 查询状态
        selectType: '',
        //订单时间
        ordertime: {
          start: '',
          end: ''
        }
      }
      this.trackOrder()
    },
    //查询订单
    async trackOrder (e) {

      if (this.queryCondition.ordertime.start != '' && this.queryCondition.ordertime.end === '') {
        return Message.error('请输入截止时间')
      } else if (this.queryCondition.ordertime.start === '' && this.queryCondition.ordertime.end != '') {
        return Message.error('请输入开始时间')
      } {

      }
      this.loading = true
      this.timeReplenish
      let res = await apiManageOrders({
        op: 'list',
        pd: 'getlist',
        page: this.page,
        pageSize: this.pageSize,
        rk: e ? 1 : '',
        type: this.queryCondition.selectType,
        // 订单状态
        status: this.queryCondition.status,
        // 国家id
        addrid: this.queryCondition.addrid[0],
        // 仓库id
        ckid: this.queryCondition.ckid,
        //物流单号
        wlnum: this.queryCondition.wlnum,
        //快递单号
        kdnum: this.queryCondition.kdnum,
        //收件人姓名
        keyword: this.queryCondition.keyword,
        //报价方案id
        bjid: this.queryCondition.bjID,
        //渠道方案id
        qdid: this.queryCondition.qdID,
        //寄件方式
        fromtype: this.queryCondition.fromtype,
        //根据用户id
        uid: this.queryCondition.uid,
        //时间
        ordertime: this.queryCondition.ordertime.start && this.queryCondition.ordertime.end === '' ? JSON.stringify({ ordertime: this.queryCondition.ordertime }) : '',

      })
      this.tableData = common.transform(res.orderlist)
      this.sourceData = ''
      this.concealOrder()
      this.pageStatus = 2
      this.ordernum = parseInt(res.totalNum)
      this.processingData(res)
      this.loading = false
      if (e) {
        e(this.tableData[0])
      }
    },
    //获取订单状态数据
    async getOrderStatus () {
      this.loading = true
      let res = await apiManageOrders({
        op: 'list',
        pd: 'getlist',
        page: this.page,
        pageSize: this.pageSize,
        status: ''
      })
      this.qdlist = common.transformValue(res.qdlist)
      this.bjlist = common.transformValue(res.bjlist)
      this.orderStatus = common.transformValue(res.zt[1][2])
      this.tableData = common.transform(res.orderlist)
      this.concealOrder()
      this.warehouseChoose = res.cklist
      this.ordernum = parseInt(res.totalNum)
      this.processingData(res)
      this.loading = false
    },

    //数据处理
    processingData (res) {
      this.zt = res.zt
    },
    //页数跳转
    pageData (e) {
      console.log(e);
      this.page = e
      if (this.pageStatus === 1) {
        this.getOrderStatus()
      } else if (this.pageStatus === 2) {
        this.trackOrder()
        this.page = 1
      }

    }
  },
  components: {
    editOrder
  },
  mounted () {
    this.getOrderStatus()
  },
  created () {
    this.upUrl = this.$store.state.upUrl;

  }
}
</script>

<style lang="scss">
@import "@/assets/css/variable.scss";
// justify-content: center;

.el-table__body {
  tr td th {
    transition: all 0.3s;
  }
}
.warehouseName {
  //   background-color: pink !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.allorders {
  width: 100%;
  height: 100%;
  // padding: 20px;
  box-sizing: border-box;
  // background-color: pink;
  flex-direction: column;
  display: flex;
  align-items: center;
  overflow: auto;
  // justify-content: center;
  .order_details {
    width: 100%;
    height: auto;
    margin-bottom: 20px;
    // border: 1px solid #eee;
    .order_details_title {
      margin-bottom: 5px;
    }
    .el-row {
      margin-bottom: 20px;
      &:last-child {
        margin-bottom: 0;
      }
    }
    .el-col {
      border-radius: 4px;
    }
    .grid-content:hover {
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
    }
    .grid-content {
      box-shadow: 0;
      border-radius: 4px;
      min-height: 36px;
      border: 1px solid #eee;
      height: 80px;
      margin-bottom: 5px;
      display: flex;
      flex-direction: column;
      transition: all 0.3s;
      .details_title {
        font-weight: 700;
        flex: 1;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        padding-left: 5px;
        color: #999;
        background-color: #f9f9f9;
      }
      .details_content {
        flex: 1;
        padding-left: 5px;
        display: flex;
        align-items: center;
      }
    }
    .row-bg {
      padding: 10px 0;
      background-color: #f9fafc;
    }
  }
  .be_putIn_storage {
    .area {
      margin: 20px;
    }
    .kdnum {
      font-style: normal;
      margin-left: 5px;
      color: $mainColor;
      width: 200px;
    }
  }
  .dialogTableVisible_1 {
    .el-dialog {
      min-width: 950px;
    }
    .orderShow_btn_control {
      width: 100%;
      height: 100px;
      // background-color: pink;
      display: flex;
      flex-wrap: wrap;
      position: relative;
      //   justify-content: center;
      // justify-content: right;
      .el-button {
        height: 40px;
        margin: 0 5px;
      }
    }
  }
  .allorders_title {
    width: 100%;
    height: 30px;
    padding-left: 2.5%;
    box-sizing: border-box;
    display: flex;
    justify-content: left;
    align-items: center;
    // border-bottom: 2px dashed #cccccc;
    transition: all 0.3s;
    background-color: #ffffff;
  }
  .allorders_search {
    width: 95%;
    margin: 10px;
    // height: 300px;
    padding: 20px;
    box-sizing: border-box;
    background-color: #fff;
    transition: all 0.3s;

    .viewMore {
      display: flex;
      justify-content: center;

      span {
        font-size: 20px;
        animation-iteration-count: 5;
        width: 20px;
        animation-duration: 1s;
        height: 20px;
        margin-top: 10px;
        cursor: pointer;
        // position: absolute;
        // left: 50%;
      }
      span:hover {
        animation-iteration-count: 1;
        width: 20px;
        animation-duration: 1s;
        height: 20px;
        margin-top: 10px;
        // position: absolute;
        // left: 50%;
      }
    }
    .operation_button {
      width: 100%;
      height: 50px;
      display: flex;
      justify-content: space-between;
      // background-color: rgb(118, 124, 184);
      .operation_button_main {
        // width: 80%;
        display: flex;
        justify-items: center;
        margin-top: 10px;
        // background-color: pink;
        // background-color: rgb(80, 194, 165);
        .tabelBorder {
          // height: 50px;
          min-width: 100px;
          line-height: 20px;
          margin: 0 10px;
          font-size: 14px;
          color: #333;
          display: flex;
          // background-color: pink;
          // justify-items: center;
          // justify-content: center;
          align-items: center;
          .el-switch {
            margin-left: 10px;
          }
        }
        .el-dropdown {
          margin-right: 10px;
        }
      }
    }
    .allorders_search_form {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: baseline;
      align-items: center;
      // background-color: pink;
      overflow: hidden;
      transition: all 0.3s;
      .allorders_search_item {
        transform: all 0.3s;
        width: 25%;
        height: 30px;
        .el-input {
          width: 60%;
        }
        .el-select,
        .el-cascader {
          width: 60%;
          .el-input {
            width: 100%;
          }
        }
        .el-input__inner {
          height: 30px !important;
        }
      }
      .allorders_search_time {
        width: 50%;
        .el-input {
          width: 30%;
          margin-right: 5px;
        }
      }
      .allorders_search_but {
        // width: 30%;
        // background-color: pink;
        text-align: left;
        button {
          margin-left: 50px;
        }
      }
    }
  }
  .orderShow {
    position: relative;
    width: 95%;
    height: 75%;
    // padding: /;
    background-color: #fff;

    .el-table__row td {
      min-height: 50px;
      max-height: 50px;
      overflow: hidden;
    }
    .paging {
      width: 100%;
      height: 80px;
      // margin-top: 10px;
      // background-color: pink;
      display: flex;
      align-items: center;
      justify-content: center;
      .paging_tetle {
        color: #333;
        margin-right: 10px;
        letter-spacing: 2px;
        font-size: 14px;
      }
      .ordernum {
        display: flex;
        justify-content: center;
        align-items: center;

        width: 80%;
        height: 100%;
        // background-color: pink;
      }
    }
    .cell {
      padding-left: 20px;
    }
  }
  .el-table--enable-row-hover .el-table__body tr:hover > td {
    background-color: rgb(185, 175, 175) !important;
    color: #fff;
  }
  .el-table--enable-row-hover .el-table__body tr td {
    transition: none !important;
  }
  .orderShow_orderDetails {
    width: 100%;
    height: 430px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-bottom: 20px;

    .el-step__title {
      letter-spacing: 2px;
    }
    ul {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .orderShow_orderDetails_sj,
      .orderShow_orderDetails_jj,
      .orderShow_orderDetails_bg,
      .orderShow_orderDetails_feeprice,
      .orderShow_orderDetails_remark {
        width: 30%;
        height: 150px;
        font-size: 12px;
        h3 {
          font-weight: normal;
          margin-bottom: 10px;
          margin-right: 5px;
        }
        i {
          color: $mainColor;
          font-style: normal;
        }
        span {
          font-size: 14px;
          color: #777;
          margin: 0 10px;
        }
      }
    }
    .orderShow_orderDetails_state {
      height: 150px;
      width: 33%;

      div {
        width: 100% !important;
        display: flex;
        align-items: baseline;
        span {
          font-size: 14px;
          color: #4c90fd;
        }
        h3 {
          font-weight: normal;
          margin-bottom: 10px;
          margin-right: 5px;
        }
        width: 30%;
        height: 25px;
        font-size: 12px;
        .orderShow_orderDetails_state_time {
          margin-left: 5px;
        }
      }
    }
    // background-color: pink;
  }
  .exhibitionData {
    // display: flex;
    .exhibitionData_span {
      margin: 20px 0;
      display: flex;
      width: 100%;
      height: 40px;
      flex-wrap: wrap;
      .el-checkbox {
        width: 120px;
      }
    }
  }
  .exportExcle {
    .exportExcle_excelName {
      margin: 20px 0 0 20px;

      width: 230px;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .el-input {
        width: 100px;
        margin-left: 5px;
      }
    }
  }
  .management_interface {
    .el-dialog {
      // width: 500px;
      min-width: 950px;

      .orderReview_bar {
        color: $mainColor;
        margin-left: 5px;
      }
      .orderPop {
        margin-bottom: 20px;
        display: flex;
        .popTitle {
          width: 100px;
          display: flex;
          justify-content: flex-end;
        }
        .orderReview_bar {
          margin-left: 20px;
        }
        .collectDriver {
          width: 320px;
          //   display: flex;
        }
      }
      .sj {
        margin: 20px 30px;
        .el-select {
          margin-left: 10px;
        }
      }
    }
  }
}
</style>